const symbolMap = {
  "+": "plus", "-": "minus", "=": "equals", "*": "times",
  "/": "divided by", "%": "percent", "^": "power",
  "×": "times", "÷": "divided by"
};

// export function customParser1(text) {
//   const SPACE = "\\ ";
//   const words = text.trim().split(/\s+/);
//   let result = SPACE + words.join(SPACE).toLowerCase();
//   for (const [symbol, word] of Object.entries(symbolMap)) {
//     const escaped = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     result = result.replace(new RegExp(escaped, "g"), ` ${word} `);
//   }

//   return `\\text{${result}}`;
// }

export function customParser1(text) {
  const words = text.trim().split(/\s+/);
  let result = " " + words.join(" ").toLowerCase();

  for (const [symbol, word] of Object.entries(symbolMap)) {
    const escaped = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    result = result.replace(new RegExp(escaped, "g"), ` ${word} `);
  }

  return result;
}